'use strict';
import {react2angular} from 'react2angular';
import SurveyMonkeyFeedback from "../../src/components/Feedback/SurveyMonkeyFeedback";

angular
    .module('dstreamApp.reactBridge')
    .component('dsSurveyMonkey', react2angular(SurveyMonkeyFeedback, [], ['$rootScope']));
